import firebase from '@/config/firebase'
import { firestoreAction } from 'vuexfire'
import globals from '@/config/globals'

const getDefaultState = () => ({
  record: null,
  profile: null,
  type: 'default',
  status: {
    value: false,
    data: null
  }
})

const account = {
  namespaced: true,

  state: getDefaultState(),

  mutations: {
    setType(state, data) {
      state.type = data
    },

    setRecord(state, data) {
      state.record = data
    },

    setStatus(state, data) {
      state.status = data
    },

    reset(state) {
      Object.assign(state, getDefaultState())
      state.status = { value: false, data: 'Data wiped.' }
    }
  },

  actions: {
    storeRecord({ commit }, user) {
      commit('setRecord', user)
      console.info('Account - Record loaded.')
    },

    loadProfile: firestoreAction(({ bindFirestoreRef, state, commit }) => bindFirestoreRef('profile', firebase.firestore().collection(globals.firebase.collection.users).doc(state.record.uid))
      .then(() => {
        commit('setStatus', { value: true, data: 'Account (Profile) Document loaded.' })
        console.info('Account - Profile document loaded.')
      })
      .catch((error) => {
        commit('setStatus', { value: false, data: error.stack.toString() })
        console.error('Error binding document (profile):', error)
      })),

    reset({ commit }) {
      commit('reset')
    }
  },

  getters: {
    type: (state) => {
      let type = 0

      if (state.profile && state.profile.type) {
        switch (state.profile.type) {
        case 1:
          type = 'admin'
          break

        case 2:
          type = 'operator'
          break

        case 3:
          type = 'dentist'
          break

        default:
          type = 'error'
        }
      }

      return type
    }
  }
}

export default account
